import type React from 'react'

interface MidpointMarkerProps {
  /** X座標 */
  cx: number
  /** Y座標 */
  cy: number
  /** カラー（デフォルト: #3b82f6 青） */
  color?: string
  /** マーカーの表示倍率。ズーム時に 1/zoomScale を渡してスクリーン上一定サイズに保つ */
  markerScale?: number
  /** クリック時のハンドラ */
  onClick: () => void
}

/**
 * 中間点追加マーカーコンポーネント
 * プラス記号で中間点追加を示す
 */
export const MidpointMarker: React.FC<MidpointMarkerProps> = ({
  cx,
  cy,
  color = '#3b82f6',
  markerScale = 1,
  onClick,
}) => {
  return (
    <g
      style={{ cursor: 'pointer', pointerEvents: 'auto' }}
      transform={`translate(${cx}, ${cy}) scale(${markerScale})`}
      onClick={e => {
        e.stopPropagation()
        onClick()
      }}
      onPointerUp={e => {
        if (e.pointerType === 'pen') {
          e.stopPropagation()
          onClick()
        }
      }}
      onTouchEnd={e => {
        e.stopPropagation()
        onClick()
      }}
    >
      {/* 透明なヒットエリア（タップしやすくする） */}
      <circle cx={0} cy={0} fill="transparent" r={16} />

      {/* 白い背景円 */}
      <circle cx={0} cy={0} fill="white" r={5} stroke={color} strokeWidth={1.5} />

      {/* プラス記号 - 横線 */}
      <line
        pointerEvents="none"
        stroke={color}
        strokeWidth={1.5}
        x1={-2.5}
        x2={2.5}
        y1={0}
        y2={0}
      />

      {/* プラス記号 - 縦線 */}
      <line
        pointerEvents="none"
        stroke={color}
        strokeWidth={1.5}
        x1={0}
        x2={0}
        y1={-2.5}
        y2={2.5}
      />
    </g>
  )
}
